import React from "react";

export default function AchievementGrid({ achievements = [] }) {
  return (
    <section className="league-panel league-profile-section">
      <div className="league-panel-head"><div><p>Standards reached</p><h2>Achievements</h2></div><span>{achievements.length} unlocked</span></div>
      <div className="league-achievement-grid">
        {achievements.length ? achievements.map((achievement) => (
          <article key={achievement.id}><i>{achievement.icon}</i><strong>{achievement.title}</strong><small>{achievement.detail}</small></article>
        )) : <div className="league-empty">Complete competitions to unlock achievements.</div>}
      </div>
    </section>
  );
}
